import axiosInstance from "./axiosInstance";

export function getDocuments() {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get("/document")
      .then((res) => resolve(res.data.data, res.data.count))
      .then((e) => reject(e));
  });
}

export function getPagenatedDocuments(page = 1) {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get("/document", {
        params: {
          page,
        },
      })
      .then((res) => resolve(res.data.data, res.data.count))
      .then((e) => reject(e));
  });
}

export function checkDocument(documentId, data) {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(`/check_document/${documentId}`, data)
      .then((res) => resolve(res.data))
      .then((e) => reject(e));
  });
}
